document.addEventListener('turbolinks:load', () => {
  $('.money').mask('#.##0,00', {reverse: true});
  var selector = document.getElementById("date_expires");
  if (selector){
    var im = new Inputmask("99/99/9999");
    im.mask(selector);
  }
});
